import React, { useState, useRef } from 'react';
import api from '../services/api';
import { toast } from './Toast';

const ImageUploader = ({ value = '', onChange, label = 'Image' }) => {
  const [uploading, setUploading] = useState(false);
  const [showTab, setShowTab] = useState(value ? 'current' : 'url'); // 'url' ou 'upload'
  const fileInputRef = useRef(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const res = await api.post('/upload/image', formData);
      onChange(res.data.url);
      setShowTab('current');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur upload');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="border rounded-lg p-3 bg-gray-50">
      <div className="font-medium text-sm mb-2">{label}</div>
      
      {/* Affichage courant */}
      {value && (
        <div className="mb-3">
          <img src={value} alt={label} className="max-w-xs max-h-32 rounded-lg border border-gray-300" />
        </div>
      )}

      {/* Onglets */}
      <div className="flex gap-2 mb-2 border-b">
        <button
          onClick={() => setShowTab('url')}
          className={`px-3 py-1 text-sm ${showTab === 'url' ? 'border-b-2 border-indigo-600 font-medium' : 'text-gray-500'}`}
        >
          URL
        </button>
        <button
          onClick={() => setShowTab('upload')}
          className={`px-3 py-1 text-sm ${showTab === 'upload' ? 'border-b-2 border-indigo-600 font-medium' : 'text-gray-500'}`}
        >
          Upload
        </button>
      </div>

      {/* Contenu onglet URL */}
      {showTab === 'url' && (
        <input
          type="text"
          placeholder="https://..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border rounded-lg text-sm"
        />
      )}

      {/* Contenu onglet Upload */}
      {showTab === 'upload' && (
        <div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            disabled={uploading}
            className="hidden"
          />
          <button
            onClick={() => fileInputRef.current?.click()}
            disabled={uploading}
            className="w-full px-3 py-2 border-2 border-dashed rounded-lg text-sm text-gray-600 hover:border-indigo-400 hover:text-indigo-600 disabled:opacity-50"
          >
            {uploading ? 'Téléchargement...' : 'Cliquer ou déposer une image'}
          </button>
          <div className="text-xs text-gray-500 mt-1">Max 5MB (JPEG, PNG, GIF, WebP)</div>
        </div>
      )}

      {value && (
        <button
          onClick={() => onChange('')}
          className="mt-2 text-xs text-red-600 hover:text-red-700 underline"
        >
          Supprimer
        </button>
      )}
    </div>
  );
};

export default ImageUploader;
